import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["calendarButton"]
  static values = {
    dailyViewUrl: String,
    calendarUrl: String
  }

  connect() {
    this.toggleCalendarButton()
    this.setupResizeListener()
  }

  disconnect() {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout)
    }
  }

  setupResizeListener() {
    window.addEventListener('resize', this.handleResize.bind(this))
  }

  handleResize() {
    clearTimeout(this.resizeTimeout)
    this.resizeTimeout = setTimeout(() => {
      this.toggleCalendarButton()
    }, 250)
  }

  toggleCalendarButton() {
    if (this.hasCalendarButtonTarget) {
      if (this.isDesktop()) {
        this.calendarButtonTarget.style.display = 'block'
      } else {
        this.calendarButtonTarget.style.display = 'none'
      }
    }
  }

  isDesktop() {
    return window.innerWidth > 768
  }

  isMobile() {
    return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  }
}
